import React, { useState, useEffect } from 'react';
import { useRouter } from '../../../components';
import { useGet } from '../../../components';
import { Item } from '../../items/item';
import { NotFound } from '../../../components';
import env from '../../../env';
import { useStore } from '../../../store';
import { ErrorPopup, Loading } from '../../../components';
import { useInstagram } from '../../../components';
import { MetaTag } from '../../../components';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { gtm } from '../../../lib/tracking';

const log = (...args) => {
  //console.log(args);
}
const areEqual = (prevProps, nextProps) => {
  return (prevProps.pageData === nextProps.pageData)
};
const PageMemo = React.memo(Page, areEqual)

export function ViewPage() {
  const { dispatch } = useStore();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [data, setData] = useState(null);
  //const path = usePath();
  //log('view page', path);
  const { pathname, Redirect } = useRouter();
  useInstagram();

  const get = useGet();
  log('0. viewpage ready');

  useEffect(() => {
    log('*. start loading')
    setPageLoaded(false);
    get.send(env.apiBase + "/api/cms/GetPublishedPage?path=" + pathname);
    // eslint-disable-next-line
  }, [pathname]);

  useEffect(() => {
    if (data) {
      dispatch({ type: 'SET_PAGE', payload: data.data })
      dispatch({ type: 'SET_MENU', payload: data.menu })
    }
    // eslint-disable-next-line
  }, [data]);

  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  //log(router.pathname);
  //log(get.loading());
  log('1. viewpage component', pageLoaded, get.response);


  const pageData = get.response.data;
  //const menuData = get.response.menu;
  const redirectTo = get.response.redirectTo;

  const cmsOption = {};

  log(pageLoaded, !pageLoaded && !!pageData)
  if (!pageLoaded && pageData) {
    //log(pageLoaded, pageData, menuData)
    log('2. dispatching page & menu')
    setPageLoaded(true);
    setData(get.response);
    document.title = pageData.pageTitle;
    gtm.pageView(pathname, pageData.pageTitle);
    return null;
  } else if (redirectTo) {
    if (redirectTo.indexOf('http') >= 0 && typeof window !== `undefined`) {
      return window.location.href = redirectTo;
    } else {
      return <Redirect to={redirectTo} />
    }
  } else if (!pageLoaded && !pageData) {
    setPageLoaded(true);
    setData(get.response);
    return (<NotFound />)
  }

  log('3. call rendering memo')
  if (pageData) {
    
    return <PageMemo pageData={pageData} cmsOption={cmsOption} />;
  }
  else
    return <NotFound />
}

// change page structure on the fly
function alterPageData(pageData) {
  if (!pageData || !pageData.pageUrl) return;
  if (pageData.pageUrl.indexOf('/recipe-') === 0) {
    try {
      const inx = utils.array.findIndex(pageData.sections[0].items, x => x.itemTypeCode === 'Panel')
      if (inx >= 0) {
        const newItem = { "itemTypeCode": "PrintShare", "cssClass": null, "anchorName": null, "itemId": null, "payloads": [], "items": [] }
        utils.array.insertItem(pageData.sections[0].items[inx].items, 0, newItem)
      }
    } catch (e) { }
  }
  else if (pageData.pageUrl.indexOf('/recipe/') === 0) {
    try {
      const inx = utils.array.findIndex(pageData.sections[0].items, x => x.itemTypeCode === 'Panel')
      if (inx >= 0) {
        const newItem = { "itemTypeCode": "PrintShare", "cssClass": "blog__type", "anchorName": null, "itemId": null, "payloads": [], "items": [] }
        utils.array.insertItem(pageData.sections[0].items[inx].items, 0, newItem)
      }
    } catch (e) { }
  }
  //console.log(pageData)
}

function Page(props) {
  const pageData = props.pageData;
  const cmsOption = props.cmsOption;

  alterPageData(pageData);

  cmsOption.pageData = pageData;
  // document.title = pageData.pageTitle;
  log('4. page rendering', pageData, cmsOption)
  
  // Add Recipe Schema for recipe pages
  const isRecipePage = pageData.pageUrl && (
    pageData.pageUrl.indexOf('/recipes/') === 0 || 
    pageData.pageUrl.indexOf('/recipe/') === 0 ||
    pageData.pageUrl.indexOf('/recipe-') === 0 ||
    pageData.pageUrl.includes('/recipes/') ||
    pageData.pageUrl.includes('/recipe/') ||
    pageData.pageUrl.includes('/recipe-') ||
    pageData.pageUrl.includes('recipes') ||
    pageData.pageUrl.includes('recipe')
  );
  
  // Additional fallback: check if page title or description contains recipe keywords
  const hasRecipeKeywords = pageData.pageTitle && (
    pageData.pageTitle.toLowerCase().includes('recipe') ||
    pageData.pageTitle.toLowerCase().includes('cooking') ||
    pageData.pageTitle.toLowerCase().includes('dish') ||
    pageData.pageTitle.toLowerCase().includes('meal')
  );
  
  const finalIsRecipePage = isRecipePage || hasRecipeKeywords;
  
  // Debug logging for recipe detection
  console.log('Recipe Page Detection:', {
    pageUrl: pageData.pageUrl,
    isRecipePage: finalIsRecipePage,
    pageTitle: pageData.pageTitle,
    pageTypeCode: pageData.pageTypeCode,
    fullPageData: pageData
  });
  
  // Use useEffect to ensure schema is properly injected
  React.useEffect(() => {
    // Always inject organization schema on all pages
    const existingOrgSchema = document.querySelector('script[data-org-schema="true"]');
    if (existingOrgSchema) {
      existingOrgSchema.remove();
    }
    
    // Create and inject the organization schema script
    const orgSchemaScript = document.createElement('script');
    orgSchemaScript.type = 'application/ld+json';
    orgSchemaScript.setAttribute('data-org-schema', 'true');
    orgSchemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://cuisinart.com.au/#organization",
      "name": env.siteName,
      "url": "https://cuisinart.com.au",
      "logo": "https://cuisinart.com.au/sites/cuisinart/media/app/logo-colour.png",
      "description": "Cuisinart - Premium kitchen appliances and cooking equipment for home chefs",
      "foundingDate": "1971",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": utils.site.isNZ ? "NZ" : "AU",
        "addressLocality": utils.site.isNZ ? "Auckland" : "Sydney",
        "addressRegion": utils.site.isNZ ? "Auckland" : "NSW"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "availableLanguage": "English"
      },
      "sameAs": [
        "https://www.facebook.com/cuisinart",
        "https://www.instagram.com/cuisinart",
        "https://www.youtube.com/cuisinart"
      ]
    });
    
    // Inject organization schema into head
    document.head.appendChild(orgSchemaScript);
    
    // Recipe schema injection (existing code)
    if (finalIsRecipePage) {
      // Remove any existing recipe schema
      const existingSchema = document.querySelector('script[data-recipe-schema="true"]');
      if (existingSchema) {
        existingSchema.remove();
      }
      
      // Create and inject the schema script
      const schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.setAttribute('data-recipe-schema', 'true');
      schemaScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Recipe",
        "@id": `https://cuisinart.com.au${pageData.pageUrl}`,
        "name": pageData.pageTitle,
        "description": cmsUtils.payload(pageData, 'Description') || pageData.pageTitle,
        "image": cmsUtils.payload(pageData, 'ImageUrl') ? `https://cuisinart.com.au${cmsUtils.payload(pageData, 'ImageUrl')}` : "",
        "url": `https://cuisinart.com.au${pageData.pageUrl}`,
        "author": {
          "@type": "Organization",
          "name": env.siteName
        },
        "publisher": {
          "@type": "Organization",
          "name": env.siteName,
          "url": "https://cuisinart.com.au"
        },
        "recipeCategory": "Recipe",
        "recipeCuisine": "International",
        "prepTime": "PT30M",
        "cookTime": "PT45M",
        "totalTime": "PT1H15M",
        "recipeYield": "4 servings",
        "nutrition": {
          "@type": "NutritionInformation",
          "calories": "300 calories"
        },
        "datePublished": new Date().toISOString().split('T')[0],
        "dateModified": new Date().toISOString().split('T')[0]
      });
      
      // Inject into head for better detection
      document.head.appendChild(schemaScript);
    }
  }, [finalIsRecipePage, pageData.pageTitle]);
  
  const sectionItems = pageData.sections.map((section, index) => {
    return (
      <Section item={section} key={section.sectionName + index} cmsOption={cmsOption}></Section>
    )
  }
  );
  return (
    <>
      {/* Recipe Schema is now injected via useEffect */}
      
      <MetaTag data={getMetaTag(pageData)} />
      
      <div className={`cmsPage cmsPage--${pageData.pageTypeCode}`}>
        {sectionItems}
      </div>
    </>
  );
}

function Section(props) {
  log('5. section rendering')
  const item = props.item;
  //const sectionName = item.sectionName;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  if (!subItems || subItems.length === 0)
    return (<></>);

  const subItemsElts = subItems.map((subItem, index) =>
    <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
  );
  return (
    <>
      {subItemsElts}
    </>
  );
}

function getMetaTag(pageData) {
  const country = utils.site.isNZ ? 'New Zealand' : 'Australia'
  const siteName = env.siteName + ' ' + country;

  return {
    title: pageData.pageTitle + ' | ' + siteName,
    description: cmsUtils.payload(pageData, 'Description'),
    keywords: cmsUtils.payload(pageData, 'Keyword'),
    heroImageUrl: utils.site.fullUrl(cmsUtils.payload(pageData, 'ImageUrl')),
    language: 'English',
    country: country,
    siteName: siteName,
    url: utils.site.fullUrl(pageData.pageUrl),
    //canonical: utils.site.resourcePath(pageData.pageUrl)
  }
}